import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.377 5.223a1.623 1.623 0 1 1 3.246 0v.318H6.377v-.318Zm-1.4.318v-.318a3.023 3.023 0 1 1 6.046 0v.318h1.107a.65.65 0 0 1 .65.65v6.71a.65.65 0 0 1-.65.65H3.87a.65.65 0 0 1-.65-.65v-6.71a.65.65 0 0 1 .65-.65h1.107Zm-.457 6.71v-5.41h6.96v5.41H4.52Zm4.433-3.16a.95.95 0 0 1-.303.697v.93a.65.65 0 1 1-1.3 0v-.93a.953.953 0 1 1 1.603-.697Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=LockIcon16.js.map